import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=e242e24e&scoped=true"
import script from "./AnnouncementList.vue?vue&type=script&lang=js"
export * from "./AnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementList.vue?vue&type=style&index=0&id=e242e24e&prod&lang=scss&scoped=true"
import style1 from "./AnnouncementList.vue?vue&type=style&index=1&id=e242e24e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e242e24e",
  null
  
)

export default component.exports